import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { DocumentFileType, DoNotRenewalPolicyReasons, LOBType, LocationType, RenewalPolicyOptionsValue, YesNo, YesNoValue } from 'src/app/_common/_enum/module.enum';
import { HeaderData } from 'src/app/_models/header-data';
import { Renewal } from '../../_models/start-renewal';
import { RenewalsService } from '../../_services/renewals.service';

@Component({
  selector: 'app-change-renewal-request-review',
  templateUrl: './change-renewal-request-review.component.html',
  styleUrls: ['./change-renewal-request-review.component.scss']
})
export class ChangeRenewalRequestReviewComponent implements OnInit {

  //Create HeaderData object to show the Data on Blue Header.
  private headerData: HeaderData;
  private renewalReview: Renewal;
  
  private RenewalPolicyOptionsValue = RenewalPolicyOptionsValue;
  private DoNotRenewalPolicyReasons = DoNotRenewalPolicyReasons;
  private YesNoEnum = YesNo;
  private YesNoValueEnum = YesNoValue; //Using it in HTML

  private renewalData;
  private renewalAccountData;
  private auExposuresOptions;         // Using it in HTML
  private exExposuresOptions;         // Using it in HTML

  private isSubmitted: boolean = false;

  @ViewChild("reviewForm", {static: false}) reviewForm: NgForm;
  constructor(private renewalsService: RenewalsService) { }

  ngOnInit() {
    this.renewalReview = this.getRenewal();
    this.renewalData = this.renewalReview.renewalData;
    this.renewalAccountData = this.renewalsService.getRenewalAccountData();

     /* Setting Headers Starts */
      this.headerData = new HeaderData();
      this.setHeaderData();
    /* Setting Headers Ended */

    //this.renewalData = {"account":{"accountNumber":10096907,"originalName":"blanco ny gl im april 16 f GCP 1M","requestedName":"blanco ny gl im april 16 f GCP 3M","changeReason":"Business changed their name","other":""},"address":{"original":[{"addressType":"Business","careof":"","addressLine1":"121 Main St","addressLine2":"","city":"Chester","state":"NY","zip":"10918-1495","country":"US","county":"Unknown","verified":"Verified","isEdited":false},{"addressType":"Mailing","careof":"","addressLine1":"121 Main St","addressLine2":"","city":"Chester","state":"NY","zip":"10918-1495","country":"US","county":"Unknown","verified":"Verified","isEdited":false},{"addressType":"Billing","careof":"","addressLine1":"121 Main St","addressLine2":"","city":"Chester","state":"NY","zip":"10918-1495","country":"US","county":"Unknown","verified":"Verified","isEdited":false}],"requested":[{"addressType":"Business","careof":"","addressLine1":"121 Main St","addressLine2":"","city":"Chester","state":"NY","zip":"10918","country":"US","county":"Unknown","verified":"Verified","isEdited":true},{"addressType":"Mailing","careof":"","addressLine1":"121 Main St","addressLine2":"","city":"Chester","state":"NY","zip":"10918-1495","country":"US","county":"Unknown","verified":"Verified","isEdited":false},{"addressType":"Billing","careof":"","addressLine1":"121 Main St","addressLine2":"","city":"Chester","state":"NY","zip":"10918-1495","country":"US","county":"Unknown","verified":"Verified","isEdited":false}]},"contacts":{"original":[{"firstName":"barb","lastName":"barbara","roleName":"Audit","email":"aa@aol.com","phone":"(485)999-9999"},{"firstName":"barb","lastName":"barbara","roleName":"Billing","email":"aa@aol.com","phone":"(485)999-9999"}],"requested":[{"firstName":"barb","lastName":"barbara","roleName":"Audit","email":"aa@aol.com","phone":"(485)999-8888", "isEdited": true},{"firstName":"barb","lastName":"barbara","roleName":"Billing","email":"aa@aol.com","phone":"(485)999-9999"}]},"diceExposure":{"annualGPC":50000,"yearGPC":60000,"mediaTypes":["Commercial","Industrial","Other"],"additionalInfo":"Media type other goes here.."},"renewingPolicies":[{"policyNumber":"PK202100010151","productName":"Package (UAT6-ISO-Accenture)","lobCode":"PK","lobs":["CommercialAuto","GeneralLiability","InlandMarine"],"isPrimaryLine":true,"doNotRenewReason":"","renewOption":"renew"}],"exposures":[{"name":"COMMON","lobName":"","options":[{"keyValueID":"1","shortText":"New Exposures","fullText":"Does this account have any new exposures?","value":"Yes","additionalInfo":"New exposure description goes here..."},{"keyValueID":"2","shortText":"Changed Exposures","fullText":"Have any exposures changed?","value":"No","additionalInfo":""}]},{"name":"AU","lobName":"CommercialAuto","options":[{"keyValueID":"1","shortText":"Auto Liabililty","fullText":"Non-Owned Hired Auto Liability Coverage","value":false,"additionalInfo":"","doesNotApplicable":false},{"keyValueID":"2","shortText":"Number of Employees","fullText":"Number of Employees","value":null,"additionalInfo":"","doesNotApplicable":true},{"keyValueID":"3","shortText":"Number of Partners","fullText":"Number of Partners","value":3000,"additionalInfo":"","doesNotApplicable":false},{"keyValueID":"4","shortText":"Estimated Cost of Hire","fullText":"Estimated Cost of Hire","value":1000,"additionalInfo":"","doesNotApplicable":false},{"keyValueID":"5","shortText":"UM/UIM (Optional Coverage)","fullText":"UM/UIM (Optional Coverage)","value":"Accept","additionalInfo":"","doesNotApplicable":false}]}],"selectedOptions":[{"category":"","infos":[]}],"comment":"Additional Comments goes here...","quoteNeedByDate":null,"noQuoteNeeded":true};
  
    if(this.hasAuExposures){
      this.auExposuresOptions = this.renewalData.exposures.find(_exposure => _exposure.name == LOBType.Automobile).options;
    }

    if(this.hasExUmExposures){
      this.exExposuresOptions = this.renewalData.exposures.find(_exposure => _exposure.name == LOBType.Excess_Umbrella).options;
    }
    window.scrollTo(0, 0);
  }

  setHeaderData(){
    this.headerData.pageTitle = "Change Request Review";

    this.renewalsService.header = this.headerData;
  }
  getRenewal(){
    return this.renewalsService.renewal;
  }

  getAddressLabel(_addressType) {
    if (_addressType == LocationType.PRIMARY_LABEL || _addressType == LocationType.BUSINESS_LABEL) {
      return LocationType.PRIMARY;
    }else if (_addressType == LocationType.MAILING_LABEL) {
      return LocationType.MAILING_ADDRESS;
    }else if (_addressType == LocationType.BILLING_LABEL) {
      return LocationType.BILLING_ADDRESS;
    } else {
      return _addressType;
    }
  }

  hasRenewingPolicies() {
    return this.renewalData.renewingPolicies.find(_policy => _policy.renewOption == RenewalPolicyOptionsValue.RENEW || _policy.renewOption == RenewalPolicyOptionsValue.REQUOTE_WITH_CHANGES || _policy.renewOption == RenewalPolicyOptionsValue.NO_REQUOTE_NEEDED);
  }
  
  getRenewOptionLabel(_renewOption) {
    if (_renewOption == RenewalPolicyOptionsValue.REQUOTE_WITH_CHANGES) {
      return "Requote with changes";
    }else if (_renewOption == RenewalPolicyOptionsValue.NO_REQUOTE_NEEDED) {
      return "No requote needed";
    } else if (_renewOption == RenewalPolicyOptionsValue.DO_NOT_RENEW) {
      return "Do not renew";
    } else {
      return _renewOption;
    }
  }

  get hasCompanyNameChanged(): boolean{
    return this.renewalData.account && this.renewalData.account.requestedName != "" && this.renewalData.account.originalName !== this.renewalData.account.requestedName;
  }
  
  get hasAddressChanged(): boolean{
    return this.renewalData.address && this.renewalData.address.requested && this.renewalData.address.requested.some((_address) => _address.isEdited);
  }
  
  get hasContactChanged(): boolean{
    return this.renewalData.contacts && this.renewalData.contacts.requested && this.renewalData.contacts.requested.some((_contact) => _contact.isEdited);
  }
  
  get hasAuExposures(): any {
    return this.renewalData.exposures && this.renewalData.exposures.find(_exposure => _exposure.name == LOBType.Automobile);
  }
  get hasExUmExposures(): any {
    return this.renewalData.exposures && this.renewalData.exposures.find(_exposure => _exposure.name == LOBType.Excess_Umbrella);
  }
  
  getSupportingDocuments(){
    let docFiles = this.renewalsService.getSupportingDocuments().filter(_docFile=>{return _docFile.docFileType == DocumentFileType.Other});

    return docFiles;
  }

  get primaryRenewingPolicy() {
    return this.renewalData.renewingPolicies.find(_policy => _policy.isPrimaryLine);
  }

  onContinue():boolean{    
    this.isSubmitted = true;
    return (this.reviewForm.valid);
  }
}
